import { NO_LONGER_AWAITING_COPY } from '../lib/clientApprovalPortal';

/**
 * #3187 APPROVE.4 gap G2 (ruling 6564588711) — where a redeemed approval link
 * lands when there is no OPEN request for its version, its approver and its
 * workspace (superseded, closed, the approver removed). One fixed page: it
 * fetches nothing and names no request, version or reason.
 */
export default function ClientApprovalUnavailablePage() {
  return (
    <div data-testid="approval-unavailable" style={{ maxWidth: 640, margin: '0 auto', padding: 32 }}>
      <h1 style={{ fontSize: 20, fontWeight: 700, marginBottom: 8 }}>{NO_LONGER_AWAITING_COPY}</h1>
      <p style={{ fontSize: 14, color: 'var(--text-secondary, #6b7280)' }}>
        There is nothing to decide from this link. If you expected to review something, sign in to the Client Portal.
      </p>
    </div>
  );
}
